import React from "react";
import "./Button.css";
import blackArrow from "../Images/blackArrow.png";
import purpleArrow from "../Images/purpleArrow.png";

const Button = ({ text, link, arrowColor }) => {
  return (
    <button className="common-btn">
      {text || "Read More"}
      {/* <img src={arrowColor === "black" ? blackArrow : whiteArrow} alt="arrow" /> */}
      <img src={arrowColor === "black" ? blackArrow : purpleArrow} alt="arrow" />
    </button>
  );
};

export default Button;
